<script>
export default {
  props: {
    tab: Object,
    isActive: Boolean,
  },
};
</script>

<template>
  <div class="tab" v-show="isActive">
    <div class="tab-desc">
      <div class="container-fluid" v-if="tab.imageId || tab.embedLink">
        <div
          class="d-flex justify-content-center row flex-row-center"
          v-if="tab.content"
        >
          <div class="col-md-7">
            <img
              v-if="tab.imageId"
              :src="tab.imageUrl"
              :alt="tab.title"
              class="img-responsive"
            />
            <div v-if="tab.embedLink" v-html="tab.embedLink" class=""></div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-lg-10 offset-lg-1">
                <!-- <h1>{{tab.title}}</h1> -->
                <div v-html="tab.content"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center row flex-row-center" v-else>
          <div class="col-xl-8 col-lg-10 text-center">
            <img
              v-if="tab.imageId"
              :src="tab.imageUrl"
              :alt="tab.title"
              class="img-responsive"
            />
            <div v-if="tab.embedLink" v-html="tab.embedLink" class=""></div>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-else-if="tab.label == 'Sizechart'">
        <div class="d-flex justify-content-center row flex-row-center">
          <div class="col">
            <div v-html="tab.content"></div>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-else>
        <div class="d-flex justify-content-center row flex-row-center">
          <div class="col-xl-8 col-lg-10 text-center">
            <!-- <h1>{{tab.title}}</h1> -->
            <div v-html="tab.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
